import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbTrail = ({ customItems }) => {
  const location = useLocation();

  const routeLabels = {
    '/admin-shipments-dashboard': 'Tableau de bord',
    '/create-new-shipment': 'Nouveau envoi',
    '/shipment-detail-management': 'Détails de l\'envoi'
  };

  const generateBreadcrumbs = () => {
    if (customItems) {
      return customItems;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [
      { label: 'Tableau de bord', path: '/admin-shipments-dashboard' }
    ];

    if (location?.pathname !== '/admin-shipments-dashboard') {
      const currentLabel = routeLabels?.[location?.pathname] || pathSegments?.[pathSegments?.length - 1];
      breadcrumbs?.push({ label: currentLabel, path: location?.pathname });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1 && location?.pathname === '/admin-shipments-dashboard') {
    return null;
  }

  return (
    <nav className="bg-background border-b border-border px-4 sm:px-6 lg:px-8 py-3" aria-label="Breadcrumb">
      <div className="max-w-7xl mx-auto">
        <ol className="flex items-center space-x-2 text-sm">
          {breadcrumbs?.map((crumb, index) => {
            const isLast = index === breadcrumbs?.length - 1;
            const isFirst = index === 0;

            return (
              <li key={crumb?.path} className="flex items-center">
                {!isFirst && (
                  <Icon 
                    name="ChevronRight" 
                    size={16} 
                    className="text-muted-foreground mx-2" 
                  />
                )}
                {isLast ? (
                  <span className="text-foreground font-medium truncate max-w-xs">
                    {crumb?.label}
                  </span>
                ) : (
                  <Link
                    to={crumb?.path}
                    className="text-muted-foreground hover:text-primary transition-smooth truncate max-w-xs"
                  >
                    {crumb?.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default BreadcrumbTrail;